import { GgrSettings } from "services/settings/type"

export const formatClipboardDate = (iso?: string) => {
  if (!iso) return ""
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso

  const pad = (n: number) => n.toString().padStart(2, "0")

  const day = pad(d.getDate())
  const month = pad(d.getMonth() + 1)
  const year = d.getFullYear()
  const hours = pad(d.getHours())
  const minutes = pad(d.getMinutes())
  const seconds = pad(d.getSeconds())

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`
}

export type ScopeState = {
  enabled: boolean
  limit: number | null
  snapshot: GgrSettings["cache"] | null
  isLimitReached: boolean
}

export const formatUsd = (cents: number) =>
  (cents / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })

export const EMPTY_SCOPE: ScopeState = { enabled: false, limit: null, snapshot: null, isLimitReached: false }

export function parseGgrResponse(ggr: GgrSettings | null): ScopeState {
  if (!ggr) return EMPTY_SCOPE
  return {
    enabled: ggr.enabled,
    limit: ggr.limit ?? null,
    snapshot: ggr.cache ?? null,
    isLimitReached: !!ggr.isLimitReached
  }
}

export function getPercent(s: ScopeState): number {
  if (!s.enabled || !s.snapshot) return 0
  if (!s.limit || s.limit <= 0) return 100
  return Math.min(Math.max(Math.round((s.snapshot.current / s.limit) * 100), 0), 999)
}
